<!--模板-->
<template>
  <div class="info">
    <p class="align">《隐私政策》</p>
    <div class="textInfo">更新日期：2026年04月22日</div>
    <div class="textInfo">生效日期：2021年12月19日</div>
    <div class="textInfo">引言</div>
    <div class="textInfo">
      成都爱找我科技有限公司（以下简称“找我婚礼”）非常重视您（也称“用户”）的个人信息，并让您对个人信息拥有控制权，找我婚礼会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问找我婚礼运营的找我婚礼平台时，或使用找我婚礼提供的服务前，您需要同意本政策中关于找我婚礼如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问找我婚礼的产品和服务。<b
        >本政策中与您权益（可能）存在重大关系的条款，我们已使用加粗字体予以区别，请您重点查阅。</b
      >
    </div>
    <div class="textInfo">
      本隐私权政策旨在协助您了解找我婚礼会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。若您对本政策有任何问题，请联系：service@izhaowo.com
    </div>
    <div class="textInfo">术语</div>
    <div class="textInfo">
      Cookie：Cookie
      是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie
      使该网站可以识别您的浏览器。Cookie
      还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的
      Cookie，或者在发送 Cookie 时提示。但如果没有
      Cookie，某些网站功能或服务可能无法正常工作。
    </div>
    <div class="textInfo">
      应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。
    </div>
    <div class="textInfo">
      个人信息：用户向找我婚礼提供的、可用于识别用户的个人身份的信息，例如姓名、电子邮件地址、电话号码、银行卡号、身份证号码、住址、通讯记录等信息，或找我婚礼可以正当地通过链接找到此类信息的其他数据。
    </div>
    <div class="textInfo">
      IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP)
      地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP
      地址通常可用于识别计算机连接至互联网时所在的国家/地区。
    </div>
    <p>一. 找我婚礼如何搜集和使用您的信息？</p>
    <div class="textInfo">1. 找我婚礼如何搜集您的信息？</div>
    <div class="textInfo">
      找我婚礼提供服务时，可能会收集、储存和使用下列信息：
    </div>
    <div class="textInfo">1.1 您提供的信息</div>
    <div class="textInfo">
      1.1.1
      您在注册账户或使用找我婚礼的服务时，向找我婚礼提供的相关个人信息，例如您的<b>姓名、电子邮件地址、电话号码、住址、身份证号码等信息。</b>如果您想充分使用找我婚礼提供的各种分享功能，可能还需要<b
        >创建公开显示的个人资料，其中可能会包含您的姓名和照片。</b
      >
    </div>
    <div class="textInfo">
      1.1.2
      您通过找我婚礼的服务向其他方提供的共享信息，以及您使用找我婚礼的服务时上传、提交、存储、发送或接收的信息。
    </div>
    <div class="textInfo">1.2 您在使用服务过程中，找我婚礼获取的信息</div>
    <div class="textInfo">
      <b>找我婚礼会收集您使用的服务以及使用方式的信息，</b
      >如您何时在找我婚礼浏览产品，何时访问了找我婚礼的产品服务，或何时查看了找我婚礼的广告和内容。此类信息包括：
    </div>
    <div class="textInfo"><b>1.2.1 日志信息</b></div>
    <div class="textInfo">
      A.
      设备或软件信息，例如您的移动设备、网页浏览器或用于接入找我婚礼服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
    </div>
    <div class="textInfo">
      B.
      在使用找我婚礼服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用找我婚礼服务时浏览或要求提供的其他信息和内容详情；
    </div>
    <div class="textInfo"><b>1.2.2 IP地址</b></div>
    <div class="textInfo">
      A.
      有关您<b>曾使用的移动应用（APP）和其他软件的信息，</b>以及您曾经使用该等移动应用和软件的信息；
    </div>
    <div class="textInfo">
      B.
      您通过找我婚礼的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；
    </div>
    <div class="textInfo">
      C. 您通过找我婚礼的服务分享的内容所包含的信息（元数据），例如<b
        >拍摄或上传的共享照片或录像的日期、时间或地点等。</b
      >
    </div>
    <div class="textInfo">1.2.3 设备中的视频、图片等</div>
    <div class="textInfo">
      为了给您提供全方位的购物体验，经过您的授权，找我婚礼的服务器会提取您设备中的<b>视频、图片、版本号等，</b>并通过加密上传到服务器进行比对，用于匹配与该视频、图片、相对应的显示功能。
    </div>
    <div class="textInfo"><b>1.2.4 摄像头</b></div>
    <div class="textInfo">
      除本协议另有约定外，您设备上的摄像功能是保证您能多角度观看产品效果必备工具，如您禁用摄像功能，可能无法使用找我婚礼的部分产品或服务，或在使用过程中达不到最佳效果或使用受到限制。找我婚礼不会利用摄像头采集您的个人照片，除非经您授权或您自行上传、提交、发布，找我婚礼不会主动采集您设备中的图片、视频信息。
    </div>
    <div class="textInfo"><b>1.2.5 位置信息</b></div>
    <div class="textInfo">
      为了让您更快的找到周边门店和相关服务，您可以授权开启设备定位功能并使用找我婚礼基于位置提供的相关服务，当然，您也可以通过关闭定位功能随时停止找我婚礼对您的地理位置信息的收集。
    </div>
    <div class="textInfo"><b>1.2.6 通讯录和好友圈</b></div>
    <div class="textInfo">
      如您想分享找我婚礼产品内容及图片给通讯录，找我婚礼将根据您的授权上传并保存您的应用列表，并以加密方式上传并保存用户通讯录中联系人手机号码，通过与服务器中信息匹配为您提供特色服务。
    </div>
    <div class="textInfo">1.2.7 安全运行与风控验证</div>
    <div class="textInfo">
      为了保障软件与服务的安全运行，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们会收集您的<b
        >设备信息【包括:设备型号、设备名称、SIM卡序列号、设备唯一标识符(包括:<span
          style="font-weight: 600"
          >IMEI、IMSI、IDFA</span
        >)】、地理位置、存储(相册、媒体和其他文件)、浏览器类型和设置、语言设置、操作系统和应用程序版本、网络设备硬件地址(MAC地址)、登录IP地址、接入网络的方式、网络质量数据、移动网络信息(包括运营商名称)、产品版本号以及软件使用记录信息，</b
      >如您不同意我们收集前述信息，可能无法完成风控验证。请您理解，为动态检测您的账户是否存在异常登录，每次您把找我婚礼App切换至后台或重新启动程序时，我们可能会再次读取，我们将把读取频次控制在合理范围内。
    </div>
    <div class="textInfo">1.3第三方应用工具包</div>
    <div class="textInfo">
      为了能够更高效地完成产品研发，为用户提供更为多元化的服务，找我婚礼在找我婚礼
      App 中采用了第三方提供的软件开发工具包 。这种工具包通常称为 SDK（Software
      Development
      Kit），是指用于为特定的软件包、软件框架、硬件平台、操作系统等创建应用软件的开发工具的集合。找我婚礼使用的
      SDK 包括以下类型：
    </div>
    <!-- <div class="textInfo">A. 用于支持快捷注册或登录的 SDK（中国移动/联通/电信一键登录）</div>
<div class="textInfo">B. 用于优化浏览和信息发布功能的 SDK（高德定位、Weibo SDK、极光推送）</div>
<div class="textInfo">C. 用于提供支付功能的 SDK（alipay、微信支付）</div>
<div class="textInfo">D. 用于进行数据监测的 SDK（百度统计、友盟）</div>
<div class="textInfo">E. 用于故障收集分析、帐号安全性核验的 SDK（百度统计、友盟、腾讯Bugly）</div>
<div class="textInfo">F. 设备制造商和操作系统厂商的 SDK</div> -->
    <div>
      <table
        style="
          border-collapse: collapse;
          border: 1px solid #ececec;
          width: 100%;
        "
      >
        <tr>
          <td width="10%">第三方公司名称</td>
          <td width="10%">产品/类型</td>
          <td width="20%">共享信息名称</td>
          <td width="10%">使用目的</td>
          <td width="10%">使用场景</td>
          <td width="10%">共享方式</td>
          <td width="30%">共享方式 第三方个人信息处理规则</td>
        </tr>
        <tr>
          <td colspan="7">一键登录</td> 
        </tr>
        <tr>
          <td>中移互联网有限公司</td>
          <td>移动登录</td>
          <td><b>设备信息、网络设备硬件地址、网络信息、OAID</b></td>
          <td>一键登录</td>
          <td>一键登录</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="http://dev.10086.cn/docInside?contentId=10000009826805"
              target="_blank"
              >http://dev.10086.cn/docInside?contentId=10000009826805</a
            >
          </td>
        </tr>
        <tr>
          <td>中国电信股份有限公司</td>
          <td>电信</td>
          <td><b>网络信息、读取手机状态</b></td>
          <td>一键登录</td>
          <td>一键登录</td>
          <td>SDK本机采集</td>
          <td>
            <a href="https://e.189.cn/legalStatement.jsp" target="_blank"
              >https://e.189.cn/legalStatement.jsp</a
            >
          </td>
        </tr>
        <tr>
          <td>中国联通网络信息集团有限公司</td>
          <td>联通</td>
          <td><b>网络信息、读取手机状态</b></td>
          <td>一键登录</td>
          <td>一键登录</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="http://m.client.10010.com/mobileService/tuwenhunpai/notice_1527478459203.html"
              target="_blank"
              >http://m.client.10010.com/mobileService/tuwenhunpai/notice_1527478459203.html</a
            >
          </td>
        </tr>
        <tr>
          <td colspan="7">地图及定位</td>
        </tr>
        <tr>
          <td>高德软件有限公司</td>
          <td>高德地图</td>
          <td>
            <b
              >网络信息、地理位置、读取存储（信息、媒体和其他文件）权限、设备传感器信息</b
            >
          </td>
          <td>用于展现地图</td>
          <td>门店定位</td>
          <td>SDK本机采集</td>
          <td>
            <a href="https://lbs.amap.com/pages/privacy/" target="_blank"
              >https://lbs.amap.com/pages/privacy/</a
            >
          </td>
        </tr>
        <tr>
          <td>高德软件有限公司</td>
          <td>高德定位</td>
          <td>
            <b
              >地图位置（包含在后台状态下收集）、谁被信息、网络设备硬件地址、网络信息、读取存储（信息、媒体和其他文件）权限</b
            >
          </td>
          <td>帮助用户寻找附近门店时提供帮助</td>
          <td>门店定位</td>
          <td>SDK本机采集</td>
          <td>
            <a href="https://lbs.amap.com/pages/privacy/" target="_blank"
              >https://lbs.amap.com/pages/privacy/</a
            >
          </td>
        </tr>
        <tr>
          <td colspan="7">其他</td>
        </tr>
        <tr>
          <td>支付宝（中国）网络技术有限公司</td>
          <td>支付宝</td>
          <td>
            <b
              >设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限、读取手机状态</b
            >
          </td>
          <td>支持支付宝支付</td>
          <td>支付场景</td>
          <td>SDK本机采集</td>
          <td>
            <a href="https://opendocs.alipay.com/open/54" target="_blank"
              >https://opendocs.alipay.com/open/54</a
            >
          </td>
        </tr>
        <tr>
          <td>深圳市腾讯计算机系统有限公司</td>
          <td>微信开放平台</td>
          <td><b>/</b></td>
          <td>支持微信授权登陆场景和支付场景</td>
          <td>使用微信登录、微信分享和支付场景</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
              target="_blank"
              >https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a
            >
          </td>
        </tr>
        <tr>
          <td>深圳市腾讯计算机系统有限公司</td>
          <td>QQ开放平台</td>
          <td>
            <b
              >设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限</b
            >
          </td>
          <td>帮助用户分享内容到QQ</td>
          <td>帮助用户分享内容到QQ</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e"
              target="_blank"
              >https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e</a
            >
          </td>
        </tr>
        <tr>
          <td>北京微梦创科网络技术有限公司</td>
          <td>微博</td>
          <td>
            <b
              >设备信息、网络设备地址、网络信息、读取存储（信息、媒体和其他文件）权限</b
            >
          </td>
          <td>帮助用户分享内容至微博</td>
          <td>分享至微博</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3"
              target="_blank"
              >https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3</a
            >
          </td>
        </tr>
        <tr>
          <td>阿里巴巴集团控股有限公司</td>
          <td>阿里云</td>
          <td><b>网络信息、读取存储（信息、媒体和其他文件）权限</b></td>
          <td>用于笔记发布、请柬制作、图片存储</td>
          <td>用户制作请柬、发布笔记的场景</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a"
              target="_blank"
              >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
            >
          </td>
        </tr>
        <tr>
          <td>阿里巴巴集团控股有限公司</td>
          <td>阿里云OSS</td>
          <td><b>网络信息、读取存储（信息、媒体和其他文件）权限</b></td>
          <td>用于笔记发布、请柬制作、图片存储</td>
          <td>用户制作请柬、发布笔记的场景</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a"
              target="_blank"
              >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
            >
          </td>
        </tr>
        <tr>
          <td>百度在线网络技术（北京）有限公司</td>
          <td>百度统计</td>
          <td>
            <b
              >【安卓】设备信息（设备型号、系统版本、oaid、IMEI、设备MAC地址、软件安装列表、通讯录和短信）、日志信息、应用程序列表信息、设备信息、读取/写入外部存储卡、获取运行列表、查看WLAN连接、读取手机状态和身份、使用蓝牙
              【IOS】设备信息（设备型号、系统版本、系统总内存占用空间、操作系统等基础信息）、日志信息、应用程序列表信息、剪切板中的口令、链接等内容、读取/写入外部存储卡、获取运行列表、查看WLAN连接、使用蓝牙、广告标识符IDFA
            </b>
          </td>
          <td>
            用于进行各功能的使用量、版本覆盖率等有助开发者、运营人员改善服务的数据监测，并且已做脱敏处理
          </td>
          <td>
            （1）应用第一次安装启动时，收集系统基础信息和软件版本号
            （2）新页面加载时，收集页面路径的加载次数等
            （3）退出页面时，收集页面停留时长和页面路径退出次数。
            （4）当有埋点时，收藏其他按钮的点击次数信息
          </td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://tongji.baidu.com/web/help/article?id=330&type=0"
              target="_blank"
              >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
            >
          </td>
        </tr>
        <tr>
          <td>北京巨量引擎网络技术有限公司</td>
          <td>巨量引擎</td>
          <td><b>设备信息、网络设备地址、网络信息</b></td>
          <td>用于收集广告推广效果</td>
          <td>应用第一次安装启动时</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://open.oceanengine.com/labels/7/docs/1730079845340164"
              target="_blank"
              >https://help.aliyun.com/document_detail/372512.html?spm=5176.22414175.sslink.1.6ab16422P6Ls9a</a
            >
          </td>
        </tr>
        <tr>
          <td>深圳市和讯华谷信息技术有限公司</td>
          <td>极光</td>
          <td><b>设备信息、地理位置、网络信息</b></td>
          <td>推送消息</td>
          <td>应用第一次安装启动时</td>
          <td>SDK本机采集</td>
          <td>
            <a href="https://www.jiguang.cn/license/privacy" target="_blank"
              >https://www.jiguang.cn/license/privacy</a
            >
          </td>
        </tr>
        <tr>
          <td>深圳市和讯华谷信息技术有限公司</td>
          <td>极光</td>
          <td><b>设备信息、地理位置、网络信息</b></td>
          <td>一键登录</td>
          <td>用户登录时</td>
          <td>SDK本机采集</td>
          <td>
            <a href="https://www.jiguang.cn/license/privacy" target="_blank"
              >https://www.jiguang.cn/license/privacy</a
            >
          </td>
        </tr>
        <tr>
          <td>武汉极意网络科技有限公司</td>
          <td>极验</td>
          <td>
            <b
              >手机号、运营商类型、SDK版本信息、应用名称、设备制造商、设备型号、设备宽高</b
            >
          </td>
          <td>短信防刷</td>
          <td>短信获取超过3次时</td>
          <td>SDK本机采集</td>
          <td>
            <a href="https://www.geetest.com/Private" target="_blank"
              >https://www.geetest.com/Private</a
            >
          </td>
        </tr>
        <tr>
          <td>深圳市腾讯计算机系统有限公司</td>
          <td>腾讯移动分析平台mta</td>
          <td>
            <b
              >设备信息、网络信息、获取运行列表、查看WLAN连接、读取手机状态和身份</b
            >
          </td>
          <td>用于收集应用的页面加载和点击事件</td>
          <td>App启动时</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://privacy.qq.com/policy/tencent-privacypolicy"
              target="_blank"
              >https://privacy.qq.com/policy/tencent-privacypolicy</a
            >
          </td>
        </tr>

        <tr>
          <td>华为推送SDK</td>
          <td>华为软件技术有限公司</td>
          <td>
            <b
              >应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息</b
            >
          </td>
          <td>提供消息推送服务 统计华为推送SDK接口调用成功率</td>
          <td>App启动时</td>
          <td>SDK本机采集</td>
          <td>
            <a
              href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
              target="_blank"
              >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a
            >
          </td>
        </tr>
        <tr>
          <td>Flyme推送SDK</td>
          <td>珠海星纪魅族信息技术有限公司</td>
          <td><b>手机品牌、手机型号、系统版本、系统语言，以及设备标识符</b></td>
          <td>推送通知栏消息</td>
          <td>App启动时</td>
          <td>SDK本机采集</td>
          <td>
            <a href="http://open.flyme.cn/docs?id=202" target="_blank"
              >http://open.flyme.cn/docs?id=202</a
            >
          </td>
        </tr>
      </table>
    </div>
    <div class="textInfo">除此外，还包括其他功能相关的：</div>
    <div class="textInfo">
      A. 用于<b>进行数据监测，并且已做脱敏处理的的 SDK</b>（百度统计、友盟）
    </div>
    <div class="textInfo">
      B 用于<b>故障收集分析、帐号安全性核验</b>的
      SDK（百度统计、友盟、腾讯Bugly）
    </div>
    <div class="textInfo">2. 找我婚礼可能将上述收集的信息用作以下用途：</div>
    <div class="textInfo">2.1 向您提供服务；</div>
    <div class="textInfo">
      2.2
      <b
        >在找我婚礼提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保找我婚礼向您提供的产品和服务的安全性；</b
      >
    </div>
    <div class="textInfo">
      2.3 帮助找我婚礼设计新服务，改善找我婚礼现有服务；
    </div>
    <div class="textInfo">2.4 执行软件验证、升级服务；</div>
    <div class="textInfo">
      2.5
      应用户特殊要求而提供特定服务时，需要将信息提供给找我婚礼的关联公司、第三方或其他用户；
    </div>
    <div class="textInfo">
      2.6 其他有利于用户和找我婚礼运营者利益且不违反任何强制性法律法规的情况。
    </div>
    <div class="textInfo">2.7 让您参与有关找我婚礼产品和服务的调查</div>
    <div class="textInfo">3. 找我婚礼承诺</div>
    <div class="textInfo">
      3.1
      我们不会根据敏感类别（例如种族、宗教、性取向或健康状况）向您展示个性化广告；
    </div>
    <div class="textInfo">
      3.2
      <b
        >我们不会与广告主分享可用于识别您个人身份的信息，例如您的姓名或电子邮件地址（除非经您授权同意）；</b
      >
    </div>
    <div class="textInfo">
      3.3
      <b
        >在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。</b
      >
    </div>
    <div class="textInfo">
      4. 找我婚礼不会将您的个人信息转移或披露给任何非关联的第三方，除非：
    </div>
    <div class="textInfo">
      5.1 相关法律法规、法律程序、政府机关的强制性要求；
    </div>
    <div class="textInfo">5.2 为完成合并、分立、收购或资产转让而转移；</div>
    <div class="textInfo">3.3 事先获得您的授权；</div>
    <div class="textInfo">5.4 您使用共享功能；</div>
    <div class="textInfo">5.5 以学术研究或公共利益为目的；</div>
    <div class="textInfo">
      5.6 找我婚礼认为必要且不违反法律强制性规定的其他情形。
    </div>
    <div class="textInfo">
      6. <b>除非经过您的同意，否则找我婚礼不会向任何人提供您的敏感个人信息。</b>
    </div>
    <p><b>二. 如何更新、变更、导出、删除您的信息</b></p>
    <div class="textInfo">
      1.
      您在使用找我婚礼的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账户注册信息。
    </div>
    <div class="textInfo">
      2.
      <b
        >您可以自行从找我婚礼账号中删除您的内容或个人信息，或要求找我婚礼删除或修改信息，</b
      >例如您想要删除个人帐户，可以发送邮件到service@izhaowo.com与我们联络并提出您的要求。
    </div>
    <div class="textInfo">
      3.
      在有些情况下，找我婚礼会出于法律目的或合法业务的需要将数据保留有限的一段时间。找我婚礼会尽力确保找我婚礼的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，找我婚礼可能会过一段时间才会从找我婚礼现用的和备用的系统中删除其副本。
    </div>
    <div class="textInfo">
      4.
      <b
        >您可以随时备份个人帐户名下的内容或将其用于非找我婚礼服务，您可以发邮件到service@izhaowo.com与找我婚礼联络并提出您的要求。</b
      >
    </div>
    <p>三. 找我婚礼如何保护您的个人信息</p>
    <div class="textInfo">
      1.
      所有找我婚礼产品都内置了强大的安全功能，并且找我婚礼制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：
    </div>
    <div class="textInfo">
      （1）使用加密技术来确保您的数据在传输过程中保持私密性；
    </div>
    <div class="textInfo">
      （2）提供多种安全功能来协助您保护自己的帐号安全；
    </div>
    <div class="textInfo">
      （3）审查找我婚礼在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问找我婚礼的系统；
    </div>
    <div class="textInfo">
      （4）所有因提供服务而必须接触个人信息的找我婚礼员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。
    </div>
    <p>四. 找我婚礼如何处理未成年人提供的个人信息</p>
    <div class="textInfo">
      1.
      <b
        >找我婚礼非常重视未成年人信息的保护。找我婚礼只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。“未成年人”的定义应考虑适用的法律以及各国家和地区的文化惯例。</b
      >
    </div>
    <p>五. 您分享的信息</p>
    <div class="textInfo">
      1.
      找我婚礼会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用找我婚礼服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受找我婚礼控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。
    </div>
    <div class="textInfo">
      2.
      请您谨慎考虑通过找我婚礼的服务上传、发布和交流的信息内容。在一些情况下，您可通过找我婚礼某些服务的隐私设定来控制有权浏览您共享信息的用户范围。您可以自行删除您上传、发布或分享的信息，如要求找我婚礼为您删除您的相关信息，请发送邮件到service@izhaowo.com与找我婚礼联络并提出您的要求。
    </div>
    <div class="textInfo">
      3.
      <b
        >如您考虑弃用找我婚礼App并想清除您的个人信息，可以在<span
          style="font-weight: 600"
          >【我的-设置-注销】</span
        >中得到相关指引，我们将会在看到您的诉求后的15个工作日内删除您的个人信息及副本。</b
      >
    </div>
    <p>六. 数据传输</p>
    <div class="textInfo">
      1.
      找我婚礼维护着遍布世界各地的服务器，因此，找我婚礼处理您的信息时所用的服务器可能并不是位于您所在的国家或地区。数据保护法律因国家或地区而异，不同国家或地区的数据保护力度也是有强有弱。无论是在哪里处理您的信息，找我婚礼都会一律采用本政策中所述的保护措施。另外，找我婚礼还会遵守某些与数据传输有关的法律框架，例如“EU-US
      Privacy Shield Frameworks”和“Swiss-US Privacy Shield Frameworks”。
    </div>
    <div class="textInfo">
      2.
      收到正式的书面投诉后，找我婚礼会与投诉方联系。找我婚礼会与相应的监管机构（包括当地的数据保护机构）合作，以解决任何与传输您的数据有关且无法由找我婚礼和您直接解决的投诉。
    </div>
    <p>七. 第三方服务提供商</p>
    <div class="textInfo">
      1.
      为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但找我婚礼对于第三方提供的产品或服务没有控制权。找我婚礼无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。
    </div>
    <p>八.本政策的更新</p>
    <div class="textInfo">
      1.
      找我婚礼可能会不定期修改、更新本隐私政策，有关隐私政策的更新，找我婚礼会在找我婚礼APP中以通知公告等形式发布，您可以访问找我婚礼查询最新版本的隐私政策。<b
        >对于重大变更，找我婚礼会向您发出郑重通知（包括对于某些服务，找我婚礼会通过电子邮件发送通知，说明对隐私政策进行的更改）。</b
      >
    </div>
    <p>九. 适用范围</p>
    <div class="textInfo">
      1.
      找我婚礼的隐私政策适用于由成都爱找我科技有限公司及其关联公司提供的所有服务，包括找我婚礼及www.izhaowo.com上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。
    </div>
    <div class="textInfo">
      2.
      找我婚礼的隐私权政策不适用于第三方提供的产品和服务，例如在找我婚礼及www.izhaowo.com上由第三方提供的产品和服务，以及在找我婚礼的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。
    </div>
    <div class="textInfo">
      3.
      对于为找我婚礼的服务进行广告宣传，以及可能使用找我婚礼的cookie或其他日志信息来投放和使用广告的其他公司和组织，找我婚礼的隐私权政策并未涵盖其信息处理政策。
    </div>
  </div>
</template>

<!--样式-->
<style>
@import "../../assets/css/base.css";

.info {
  padding: 0.2rem 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.26rem;
  color: #333333;
  text-align: justify;
  line-height: 0.4rem;
  background: #fff;
}
.info > div {
  margin-bottom: 0.2rem;
}
.info > p {
  color: #151515;
  font-weight: bold;
  margin-bottom: 0.2rem;
}
.info > p.align {
  text-align: center;
  margin: 0 auto;
}
</style>

<script>
export default {
  name: "menuAddress",
  created() {
    document.title = "隐私政策";
  },
};
</script>
<style scoped>
td {
  border: 1px solid #ececec;
  text-align: center;
  padding: 0.16rem 0.1rem;
}
a {
  word-break: break-all;
  cursor: pointer;
}
b {
  font-weight: bold;
  color: #151515;
}
</style>



// WEBPACK FOOTER //
// hwPolicy.vue?694f35d4